import i18n from "../i18n";

export function getSidebarLinks(isCompanyUser, _isLoggedIn, previewMode) {
  const baseUrl = "";
  if (previewMode) {
    return [
      {
        icon: "group",
        iconColor: "#28b7d3",
        href: `${baseUrl}/talents`,
        alt: i18n.t("pages.titles.talentPool"),
      },
      {
        icon: "folder",
        iconColor: "#fc7f63",
        href: `${baseUrl}/projects`,
        alt: i18n.t("pages.titles.projects"),
      },
      {
        icon: "route",
        iconColor: "#736fdd",
        href: `${baseUrl}/relocation`,
        alt: i18n.t("pages.titles.relocation_cases"),
      },
      {
        icon: "school",
        iconColor: "#00a873",
        href: `${baseUrl}/whitepaper`,
        alt: i18n.t("pages.titles.whitepaper"),
      },
    ];
  }
  return isCompanyUser
    ? [
        {
          icon: "group",
          iconColor: "#28b7d3",
          href: `${baseUrl}/talents`,
          alt: i18n.t("pages.titles.talentPool"),
        },
        {
          icon: "folder",
          iconColor: "#fc7f63",
          href: `${baseUrl}/projects`,
          alt: i18n.t("pages.titles.projects"),
        },
        {
          icon: "route",
          iconColor: "#736fdd",
          href: `${baseUrl}/relocation`,
          alt: i18n.t("pages.titles.relocation_cases"),
        },
        {
          icon: "school",
          iconColor: "#00a873",
          href: `${baseUrl}/whitepaper`,
          alt: i18n.t("pages.titles.whitepaper"),
        },
        {
          icon: "handshake",
          iconColor: "#fc7f63",
          href: `${baseUrl}/marketplace`,
          path: `${baseUrl}/marketplace/:child?`,
          alt: i18n.t("pages.titles.marketplace"),
        },
      ]
    : [
        {
          icon: "sort",
          iconColor: "#28b7d3",
          href: `${baseUrl}/tasks`,
          alt: i18n.t("pages.titles.tasks"),
        },
        {
          icon: "attach_file",
          iconColor: "#fc7f63",
          href: `${baseUrl}/docs`,
          alt: i18n.t("pages.titles.docs"),
        },
        {
          icon: "school",
          iconColor: "#736fdd",
          href: `${baseUrl}/whitepaper`,
          alt: i18n.t("pages.titles.whitepaper"),
        },
        {
          icon: "handshake",
          iconColor: "#00a873",
          href: `${baseUrl}/marketplace`,
          path: `${baseUrl}/marketplace/:child?`,
          alt: i18n.t("pages.titles.marketplace"),
        },
      ];
}

export function getNaviDrawerLinks(isCompanyUser, isLoggedIn, previewMode) {
  let links = getSidebarLinks(isCompanyUser, isLoggedIn, previewMode);
  const baseUrl = previewMode ? "/preview" : "";

  if (isCompanyUser || previewMode) {
    return isLoggedIn
      ? [
          ...links,
          {
            icon: "settings",
            iconColor: "#28b7d3",
            href: `${baseUrl}/settings`,
            alt: i18n.t("pages.titles.settings"),
          },
          {
            icon: "partner_exchange",
            iconColor: "#fc7f63",
            href: `${baseUrl}/referral`,
            alt: i18n.t("navi_drawer.partner_program"),
          },
        ]
      : links;
  }

  links = isLoggedIn
    ? [
        ...links,
        {
          icon: "person",
          iconColor: "#28b7d3",
          href: `${baseUrl}/profile`,
          alt: i18n.t("pages.titles.profile"),
        },
        {
          icon: "settings",
          iconColor: "#fc7f63",
          href: `${baseUrl}/settings`,
          alt: i18n.t("pages.titles.settings"),
        },
        {
          icon: "favorite",
          iconColor: "#736fdd",
          href: `${baseUrl}/referral`,
          alt: i18n.t("navi_drawer.talent_referral"),
        },
      ]
    : links;

  return links;
}
